<ngx-json-ld [json]='{
    "@context": "http://schema.org",
    "@type": "WebPage",
    "name": "Hoe werkt het",
    "description": "Uitleg en prijs van de app"
}'></ngx-json-ld>

<div class="content-box content-box-responsive-single showcase showcase-right">
  <div class="mockup-showcase mockup-showcase-wide mockup-showcase-right">
    <img src="/assets/images/mockups/mockup-admin-small.png" alt="fotos"/>
  </div>
  <h1>Hoe werkt het?</h1>
  <p>Op de website kun je een gratis demo aanmaken, zodat je alles uit kunt proberen. Vervolgens kun je zelf in de werkplaats alle informatie invullen over jullie bruiloft. </p>

  <h1>Hoeveel kost het?</h1>
  <p>De app kost éénmalig €{{price / 100}}. Hiermee kun je vervolgens <strong>onbeperkt</strong> gasten uitnodigen voor je bruiloft. De gasten hoeven uiteraard niet te betalen voor de app!</p>

  <h1>Hoe nodig ik mijn gasten uit?</h1>
  <p>In de werkplaats vind je een QR-code die je op de trouwkaart kan zetten. Hiermee kunnen de gasten de app downloaden én inloggen op jullie bruiloft.</p>

  <a [routerLink]="['/', 'demo-onboarding']">
    <button type="button" class="button button-primary">maak een demo aan
      <fa-icon [icon]="['fas', 'arrow-circle-right']"></fa-icon>
    </button>
  </a>

</div>
